




























import { Component, Prop, Vue } from "vue-property-decorator";

import { DateHelper } from "@/helper/dateHelper";
import { CookieHelper } from "@/helper/cookieHelper";
import { ResourceHelper } from "@/helper/resourceHelper";

import { UserConfigColors } from "@/userConfigColors/userConfigColors";

@Component({
  components: {
  }
})
export default class SelectPeriod extends Vue {
    
    title = "投稿の取得期間";
    selectPeriod = 4;

    private onSelectPeriod(select){
        this.selectPeriod = select;
    }

    private cancel(){
        this.$router.push("/SelectTemplate");
    }

    private decision(){
        this.$emit("doCommand", "decision", this.selectPeriod);
        this.$emit("close");
    }

    private selectStyle(select){
        var style = {};
        if(this.selectPeriod == select){
            style = {
                border: "solid 3px " + this.userConfigColor
            };
        }
        return style;
    }

    private get currentRoute(){
        return this.$router.currentRoute;
    }

    private get applicationState(){
        return this.$store.getters.applicationState;
    }

    private getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    //configcolor
    private get userConfigColors() : UserConfigColors{
        return this.$store.getters.userConfigColors;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        };
    }
}
